import { useRoute } from 'vue-router'
import enUsJson from './content-en-us.json'

function compareDates(a, b) {
	const dateA = new Date(a.date)
	const dateB = new Date(b.date)
	return dateA - dateB
}

function getDateContent(date_logic) {
	const route = useRoute()
	const sortedDates = date_logic.sort(compareDates)
	let dataId = 'data'

	const dateSpan = {
		start: new Date()
	}
	if (
		import.meta.env.VITE_ENV_MODE === 'local' ||
		(import.meta.env.VITE_ENV_MODE === 'dev' && route.query.dateSpan)
	) {
		const dateStrings = route.query.dateSpan?.toString().split(',')
		dateSpan.start = dateStrings?.[0] ? new Date(dateStrings[0]) : dateSpan.start
	}

	sortedDates.forEach((item) => {
		const today = dateSpan.start
		const future = new Date(item.date)
		if (today - future >= 0) dataId = item.content
	})
	return dataId
}

export const getContentFull = (contentId, language = 'en-us', fromCms = false) => {
	if (!fromCms) {
		if (language !== 'en-us') return
		const result = enUsJson.filter(
			(json) => json.content_id.toLowerCase() === contentId.toLowerCase()
		)
		return result.length === 0 ? contentId : result[0]
	}
	return contentId
}

export const getContent = (contentId, language = 'en-us', fromCms = false) => {
	if (!fromCms && contentId) {
		if (language !== 'en-us') return
		const result = enUsJson.filter(
			(json) => json.content_id.toLowerCase() === contentId.toLowerCase()
		)
		if (result[0]?.date_logic) {
			return result.length === 0 ? contentId : result[0][getDateContent(result[0]?.date_logic)]
		} else {
			return result.length === 0 ? contentId : result[0]['data']
		}
	}
	return contentId
}

export const getExitModal = (contentId, language = 'en-us', fromCms = false) => {
	if (!fromCms) {
		if (language !== 'en-us') return
		const result = enUsJson.filter(
			(json) => json.content_id.toLowerCase() === contentId.toLowerCase()
		)
		return result.length === 0 ? contentId : result[0]['dataExitModal']
	}
	return contentId
}
